import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Form,
  Input,
  Button,
  Card,
  Typography,
  Layout,
  Row,
  Col,
  notification,
  Spin,
  theme,
  Grid,
  Image
} from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import axios from 'axios';
import './LoginPage.css';

import {BASE_URL} from '../utils/constants'

import logo from '../assets/logo-anphitrion.png';

const { Title, Text } = Typography;
const { Content } = Layout;
const { useBreakpoint } = Grid;

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const { token } = theme.useToken();

  // Determinar tamaño de pantalla
  const isMobile = !screens.sm;
  const isTablet = screens.sm && !screens.lg;
  const isDesktop = screens.lg;

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // console.log('🔐 Enviando credenciales:', { 
      //   usuario: values.usuario, 
      //   pass_length: values.pass.length 
      // });
    
      const response = await axios.post(`${BASE_URL}/api/login`, values);
    
      // console.log('✅ Respuesta del servidor:', {
      //   success: response.data.success,
      //   hasToken: !!response.data.token,
      //   user: response.data.user
      // });
    
      if (response.data.success && response.data.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        localStorage.setItem('urlReportServer', JSON.stringify(response.data.urlReportServer));      
        
        const urlReportServer = JSON.parse(localStorage.getItem('urlReportServer') || '{}');
        // console.log(" urlReportServer => ",urlReportServer);
        
    
        // console.log('📝 Datos guardados en localStorage:');
        // console.log('- Token:', localStorage.getItem('token')?.substring(0, 30) + '...');
        // console.log('- User:', JSON.parse(localStorage.getItem('user') || '{}'));
    
        notification.success({
          message: 'Login Exitoso',
          description: `Bienvenido ${response.data.user.UsuarioCorto || response.data.user.usuario}`,
        });
    
        // console.log('🔄 Redirigiendo a /dashboard...');
        navigate('/dashboard');
    
      } else {
        console.error('❌ Login fallido - respuesta sin success o token');
        notification.error({
          message: 'Error de Login',
          description: 'Respuesta inválida del servidor',
        });
      }
    } catch (error) {
      console.error('💥 Error completo:', error);
      console.error('📡 Respuesta de error:', error.response?.data);
      
      notification.error({
        message: 'Error de Login',
        description: error.response?.data?.error || 'Error al conectar con el servidor',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout className="login-layout" style={{ 
      minHeight: '100vh',
      background: `linear-gradient(135deg, ${token.colorPrimary} 0%, ${token.colorPrimaryActive} 100%)`,
      position: 'relative' 
    }}>


      <Content style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        padding: isMobile ? '60px 20px 20px' : '100px 40px 40px' 
      }}>
        <Row 
          justify="center" 
          align="middle" 
          style={{ 
            width: '100%',
            maxWidth: '1200px'
          }}
          gutter={isMobile ? [0, 24] : [48, 0]}
        >
          {/* Columna izquierda - Imagen/Logo (solo en tablet y desktop) */}
          {!isMobile && (
            <Col 
              xs={0} 
              sm={0} 
              md={12} 
              lg={14}
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: isTablet ? '20px' : '40px',
                textAlign: 'center'
              }}>
                
                <div style={{
                  width: '100%',
                  maxWidth: isTablet ? '300px' : '400px',
                  height: isTablet ? '300px' : '400px',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '24px',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)'
                }}>
                  <Title level={isTablet ? 2 : 1} style={{ 
                    color: 'white',
                    textAlign: 'center',
                    padding: '20px'
                  }}>
                    Anphitrion Hotel Web
                  </Title>
                </div>
                <Text style={{ 
                  color: 'rgba(255, 255, 255, 0.8)',
                  fontSize: isTablet ? '14px' : '16px',
                  maxWidth: '400px'
                }}>
                  Sistema integral para la gestión hotelera, reservas y control de habitaciones
                </Text>
              </div>
            </Col>
          )}

          {/* Columna derecha - Formulario */}
          <Col 
            xs={24} 
            sm={24} 
            md={12} 
            lg={10}
          >
            <Card 
              className="login-card"
              style={{
                borderRadius: isMobile ? '12px' : '16px',
                boxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)',
                border: 'none',
                padding: isMobile ? '20px' : isTablet ? '30px' : '40px'
              }}
              bodyStyle={{ 
                padding: 0
              }}
            >
              {/* Logo en mobile */}
              {isMobile && (
                <div style={{ 
                  textAlign: 'center', 
                  marginBottom: '24px',
                  padding: '0 20px'
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    backgroundColor: token.colorPrimary,
                    borderRadius: '50%',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '16px'
                  }}>
                    <UserOutlined style={{ 
                      fontSize: '32px', 
                      color: 'white' 
                    }} />
                  </div>
                  <Title level={3} style={{ 
                    margin: 0,
                    color: token.colorTextHeading
                  }}>
                    app Anphitrion
                  </Title>
                  <Text type="secondary" style={{ 
                    display: 'block',
                    marginTop: '8px',
                    fontSize: '14px'
                  }}>
                    Inicia sesión para continuar
                  </Text>
                </div>
              )}

              {/* Header del formulario */}
              <div className="login-header" style={{ 
                marginBottom: isMobile ? '24px' : '32px',
                padding: isMobile ? '0 10px' : '0'
              }}>
                {!isMobile && (
                  <div style={{ 
                    textAlign: 'center', 
                    marginBottom: '16px' 
                  }}>
                    <div style={{
                      width: '60px',
                      height: '60px',
                      backgroundColor: token.colorPrimaryBg,
                      borderRadius: '50%',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '16px'
                    }}>
                      <UserOutlined style={{ 
                        fontSize: '24px', 
                        color: token.colorPrimary 
                      }} />
                    </div>
                  </div>
                )}
                <Title 
                  level={isMobile ? 4 : 2} 
                  style={{ 
                    textAlign: 'center', 
                    margin: 0,
                    color: token.colorTextHeading,
                    fontSize: isMobile ? '20px' : isTablet ? '24px' : '28px'
                  }}
                >
                  {isMobile ? 'Iniciar Sesión' : 'Bienvenido....'}
                </Title>
                {!isMobile && (
                  <Text 
                    type="secondary" 
                    style={{ 
                      textAlign: 'center', 
                      display: 'block',
                      marginTop: '8px',
                      fontSize: isTablet ? '14px' : '16px'
                    }}
                  >
                    Ingresa tus credenciales para acceder
                  </Text>
                )}
              </div>
              
              <Form
                name="login"
                onFinish={onFinish}
                layout="vertical"
                size={isMobile ? "middle" : "large"}
                style={{ 
                  width: '100%'
                }}
              >
                <Form.Item
                  name="usuario"
                  rules={[
                    { required: true, message: 'Por favor ingrese su usuario' },
                    { min: 3, message: 'El usuario debe tener al menos 3 caracteres' }
                  ]}
                  style={{ 
                    marginBottom: isMobile ? '16px' : '20px'
                  }}
                >
                  <Input
                    prefix={<UserOutlined style={{ 
                      color: token.colorTextSecondary,
                      fontSize: isMobile ? '14px' : '16px'
                    }} />}
                    placeholder="Usuario"
                    disabled={loading}
                    size={isMobile ? "middle" : "large"}
                    style={{
                      height: isMobile ? '44px' : '48px',
                      fontSize: isMobile ? '14px' : '16px'
                    }}
                  />
                </Form.Item>

                <Form.Item
                  name="pass"
                  rules={[
                    { required: true, message: 'Por favor ingrese su contraseña' },
                    { min: 4, message: 'La contraseña debe tener al menos 4 caracteres' }
                  ]}
                  style={{ 
                    marginBottom: isMobile ? '20px' : '24px'
                  }}
                >
                  <Input.Password
                    prefix={<LockOutlined style={{ 
                      color: token.colorTextSecondary,
                      fontSize: isMobile ? '14px' : '16px'
                    }} />}
                    placeholder="Contraseña"
                    disabled={loading}
                    size={isMobile ? "middle" : "large"}
                    style={{
                      height: isMobile ? '44px' : '48px',
                      fontSize: isMobile ? '14px' : '16px'
                    }}
                  />
                </Form.Item>

                <Form.Item style={{ marginBottom: '8px' }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    loading={loading}
                    icon={loading ? <Spin size="small" /> : null}
                    size={isMobile ? "middle" : "large"}
                    style={{
                      height: isMobile ? '44px' : '48px',
                      fontSize: isMobile ? '14px' : '16px',
                      fontWeight: 500
                    }}
                  >
                    {loading ? 'Verificando...' : 'Iniciar Sesión'}
                  </Button>
                </Form.Item>

                {/* Enlace de ayuda (solo desktop) */}
                {isDesktop && (
                  <div style={{ 
                    textAlign: 'center', 
                    marginTop: '16px' 
                  }}>
                    <Text type="secondary" style={{ fontSize: '14px' }}>
                      ¿Problemas para acceder?{' '}
                      <a 
                        href="#" 
                        onClick={(e) => {
                          e.preventDefault();
                          notification.info({
                            message: 'Ayuda',
                            description: 'Contacta al administrador del sistema'
                          });
                        }}
                        style={{ fontWeight: 500 }}
                      >
                        Contactar soporte
                      </a>
                    </Text>
                  </div>
                )}
              </Form>
              
              <div className="login-footer" style={{ 
                marginTop: isMobile ? '24px' : '32px',
                paddingTop: isMobile ? '16px' : '20px',
                borderTop: `1px solid ${token.colorBorderSecondary}`,
                textAlign: 'center'
              }}>
                <Text type="secondary" style={{ 
                  fontSize: isMobile ? '12px' : '14px'
                }}>
                  Anphitrion Hotel Web © {new Date().getFullYear()}
                </Text>
                {isMobile && (
                  <Text 
                    type="secondary" 
                    style={{ 
                      display: 'block',
                      marginTop: '4px',
                      fontSize: '11px'
                    }}
                  >
                    v1.0.0
                  </Text>
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default LoginPage;